import React, { FunctionComponent, } from 'react';

import {
  Button,
  Card,
  CardContent,
} from '@mui/material';

import { AppDispatch, } from '../../store/store';
import { useTranslation, } from 'react-i18next';
import { useDispatch, } from 'react-redux';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { Container } from '@mui/system';
import SuccessMessage from '../../components/SuccessMessage/SuccessMessage';

import './SignUpComplete.css';
import useTitle from '../../helpers/use-title';
import { push } from '@lagunovsky/redux-react-router';
import {redirectBack} from "../../store/middlewares/redirect";

const SignUpComplete: FunctionComponent = () => {

  const { t } = useTranslation( [ 'signUpComplete' ] );
  const { t: tCommon } = useTranslation( [ 'common' ] );

  const dispatch = useDispatch<AppDispatch>();

  const onClick = () => {
    dispatch(redirectBack());
  }

  useTitle( tCommon( 'your-user-profile' ) );

  return (
    <AppLayout title={ tCommon( 'your-user-profile' ) }>
      <div className="page page-sign-up-complete">
        <Container>
          <Card sx={ { mt: 4 } }>
            <CardContent>
              <SuccessMessage header={ t( 'header' ) }>
                <p>
                  <strong>{ t( 'info' ) }</strong>
                </p>
                <Button
                  onClick={ onClick }
                  variant='contained'
                >{ tCommon( 'go-to-login' ) }</Button>
              </SuccessMessage>
            </CardContent>
          </Card>
        </Container>
      </div>
    </AppLayout>
  );
}

export default SignUpComplete;
